// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"e68afc67","361":"662cede7","396":"54240d88"}[chunkId] + ".chunk.css";
};